import axios from 'axios'
import qs from 'qs'
import router from '../router/index'
const localstorage = window.localStorage

// axios 配置
axios.defaults.timeout = 300000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.transformRequest = [function (data) {
//   return qs.stringify(data)
// }]
  
// http request 拦截器
axios.interceptors.request.use(config => {
  const userInfo = localstorage.getItem('userId')
 	const noLogin = window.sessionStorage.getItem('noLogin')
  if (userInfo) {
      // 为了解决之前接口请求头重复
      config.headers['authorization'] = userInfo
  }
  return config
}, function (error) {
  console.log(0, error)
  // 对请求错误做些什么
  return Promise.reject(error)
})

const get = (url, data = {}, success = () => {}, failure = () => {}, config = {}) => {
  axios.get(url, {params: data, config})
    .then(resp => {
      if (resp.data.code === 2000000) {
        success && success(resp.data.data)
      } else if (resp.data.code === 4030004){
        router.push({name:'auth-login',query:{redirect:router.history.current.fullPath,goBack:router.history.current.fullPath}})
      } else {
      	failure && failure(resp.data.msg)
      }
    })
    .catch((error) => {
      failure && failure(error)
    })
}

const post = (url, data = {}, success = () => {}, failure = () => {}, config = {}) => {
  let params = qs.stringify(data)
  try {
    config.headers['Content-Type'] === 'application/json'
    params = data
  } catch (err) {
//  console.log(err)
  }
  axios.post(url, params, config)
    .then(resp => {
      if (resp.data.code === 2000000) {
        // 需要返回请求头信息的时候可传入相应配置
        success && success(resp.data.data)
      } else if (resp.data.code === 4030004){
        router.push({name:'auth-login',query:{redirect:router.history.current.fullPath,goBack:router.history.current.fullPath}})
      } else {
      	failure && failure(resp.data.msg)
      }
    })
    .catch((error) => {
      failure && failure(error)
    })
}

export default axios

export {
  get,
  post
}
